import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    user: null,
    tokens: [],
    selectedToken: {},
    solAmountBuyTemplates: ["0.1", "0.2", "0.3", "0.5", "0.7", "1.0", "1.5", "2.0", "2.5", "3.0", "4.5", "5.0", "6.0", "7.0"],
    archiveWallets: {},
  },
  getters: {
    getUserData(state) {
      return state.user;
    },
    getTokens(state) {
      return state.tokens;
    },
    getSelectedToken(state) {
      return state.selectedToken;
    },
    getSolAmountBuyTemplates(state) {
      return state.solAmountBuyTemplates;
    },
    getArchiveWallets: (state) => (token) => {
      return state.archiveWallets[token]?.wallets || [];
    },
  },
  mutations: {
    setUser(state, data) {
      state.user = data;
    },
    setTokens(state, data) {
      state.tokens = data;
    },
    setSelectedToken(state, data) {
      state.selectedToken = data;
    },
    setSolAmountBuyTemplates(state, data) {
      state.solAmountBuyTemplates = data;
    },
    setArchiveWallets(state, data) {
      const { token, wallet } = data;
      if (!state.archiveWallets[token]) {
        state.archiveWallets[token] = { wallets: [] };
      }
      const exists = state.archiveWallets[token].wallets.some((w) => w.publicKey === wallet.publicKey);
      if (!exists) {
        state.archiveWallets[token].wallets.push(wallet);
      }
    },
    removeArchiveWallets(state, data) {
      state.archiveWallets[data.token].wallets = state.archiveWallets[data.token].wallets.filter((wallet) => wallet.publicKey !== data.wallet.publicKey);
    },
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()],
});
